exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".chart-container {\r\n    display: block;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/cotwo/cotwo-statistics/cotwo-statistics.component.css
// module id = 777
// module chunks = 0